import React from 'react';
import AssetImages from '../constants/images';
import '../constants/AssetsCss';
import { Link } from 'react-router-dom';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import GetORPostAsync from '../constants/restservice';
import Swal from 'sweetalert2'
import withRouter from '../constants/withRouter';



class Login extends React.Component {
    constructor(props) {
        super(props);
        this.onusernameChange = this.onusernameChange.bind(this);
        this.onpasswordChange = this.onpasswordChange.bind(this);
        this.onrememberChange = this.onrememberChange.bind(this);
        this.signin = this.signin.bind(this);
        this.handleKeypress = this.handleKeypress.bind(this);
        this.state = {
            username: "",
            password: "",
            remember: false,
            showpassword: false
        };
    }
    componentDidMount() {
        if (localStorage.getItem("loginuser")) {
            this.setState({ username: localStorage.getItem("loginuser"), remember: true });
        }
    }
    onusernameChange(event) {
        this.setState({ username: event.target.value });
    }
    onpasswordChange(event) {
        this.setState({ password: event.target.value });
    }
    onrememberChange(event) {
        this.setState({ remember: event.target.value });
    }
    async signin() {
        if (!this.validate()) {
            return;
        }
        if (this.state.remember) {
            localStorage.setItem("loginuser", this.state.username);
        } else {
            localStorage.removeItem("loginuser");
        }
        let jsondata = '{ "username" : "' + this.state.username + '","password" : "' + this.state.password + '"}';
        // let res = await GetORPostAsync("send_otp_login.asp", "POST", jsondata);
        // if (res.status === "error") {
        //     toast(res.message);
        //     return;
        // }
        // Swal.fire({
        //     title: 'OTP Verification',
        //     html: `<input type="text" id="login" class="form-control" placeholder="Enter your OTP here"></input>`,
        //     confirmButtonText: 'Submit',
        //     focusConfirm: false,
        //     background: '#262625',
        //     preConfirm: async () => {
        //         const login = Swal.getPopup().querySelector('#login').value
        //         if (!login) {
        //             Swal.showValidationMessage(`Enter OTP`);
        //             return;
        //         }
        let response = await GetORPostAsync('MemberLoginMobile.asp', 'POST', JSON.stringify({ username: this.state.username, password: this.state.password }), localStorage.getItem('token'));
        if (response.status == 'error') {
            //Swal.showValidationMessage(response.message);
            toast.error(response.message);
            return;
        }
        console.log(response);
        localStorage.setItem("token", response.token);
        localStorage.setItem("username", response.username);
        localStorage.setItem("fullname", response.fullname);
        toast(response.message);
        this.props.history.push({
            pathname: '/home'
        });
        //     }
        // })
    }
    handleKeypress(e) {
        //it triggers by pressing the enter key
        if (e.key === "Enter") {
            this.signin();
        }
    };
    validate() {
        let isValid = false;
        if (!this.state.username) {
            toast("Enter valid username");
        }
        else if (!this.state.password) {
            toast("Enter the password");
        }
        else {
            isValid = true;
        }
        return isValid;
    }
    render() {
        return (
            <div className="page-content login-div" style={{ height: '100vh', alignItems: 'center', flexDirection: 'row' }}>
                <div className="content-wrapper " style={{ padding: 10 }}>
                    <div className="content d-flex justify-content-center align-items-center">
                        <div className="login-form">
                            <div className="card " style={{ background: "#2f2f2f" }}>
                                <div className="card-body  mb-4">
                                    <div className="text-center mb-3">
                                        <div className='card mb-0' style={{ backgroundColor: "#1b1b1b" }}>
                                            <div className="card-body">
                                                <img src={AssetImages.logo} alt="img" className="" />
                                            </div>
                                        </div>
                                        <div class="login-separater text-center mb-5"> <span>Login to your account</span><hr /></div>
                                    </div>
                                    <div className='pt-5'>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-user inputicon"></i>
                                                <input style={{ border: 0 }} className="form-control input-field" id="memberid" name="memberid" placeholder="User Name" type="text" onChange={this.onusernameChange} value={this.state.username} />
                                            </div>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left">
                                            <div className="input-container" style={{
                                                border: "1px solid #fff",
                                                borderRadius: 5,
                                                backgroundColor: "#1e1e1e"
                                            }}>
                                                <i className="las la-lock inputicon"></i>
                                                <input style={{ border: 0 }} type={!this.state.showpassword ? "password" : "text"} onKeyPress={this.handleKeypress} className="form-control input-field" id="Password" name="Password" placeholder="Password" onChange={this.onpasswordChange} value={this.state.password} />
                                                <i className={`las la-eye${!this.state.showpassword ? "" : "-slash"} inputicon`} onClick={(e) => {
                                                    this.setState({
                                                        showpassword: !this.state.showpassword
                                                    })
                                                }}></i>
                                            </div>
                                        </div>
                                        <div className="form-group d-flex align-items-center">
                                            <div className="form-check mb-0 p-0">
                                                <label className="form-check-label align-items-center fs-14">
                                                    <input type="checkbox" name="remember" className="form-input-styled" onChange={this.onrememberChange} value={this.state.remember} /> Remember
                                                </label>
                                            </div>
                                            <Link to="/forgotpassword" className="ml-auto text-color-3 fs-14">Forgot password?</Link>
                                        </div>
                                        <div className="form-group form-group-feedback form-group-feedback-left" style={{ visibility: "hidden", height: 0 }}>
                                            <select className="form-control " id="Country" name="Country">
                                                <option value="Korea, Democratic Republic of (North Korea)">	Korea, Democratic Republic of (North Korea) 	</option>
                                            </select>
                                            <div className="form-control-feedback">
                                                <i className="icon-lock2 text-muted"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group form-group-feedback form-group-feedback-left">
                                        <button type="submit" onSubmit={this.signin} onClick={this.signin} className="btn btn-primary btn-block"><i className="las la-lock-open"></i> Sign In <i className="icon-circle-right2 ml-2"></i></button>
                                    </div>
                                    <div className="form-group content-divider">
                                        <span className="">Don't have an account?</span>
                                        <Link to="/register" style={{ fontWeight: "bold", fontSize: 14 }} className="px-2 text-color-3">Sign up</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            // <div className="page-content">
            //     <div className="content-wrapper">
            //         <div className="content d-flex justify-content-center align-items-center">
            //             <div className="login-form">
            //                 <div className="card">
            //                     <div className="card-body mb-4">
            //                         <div className="text-center mb-3">
            //                             <img src={AssetImages.logo} alt="img" className="mb-3" />
            //                             <h5 className="mb-0">Login to your account</h5>
            //                             <span className="d-block text-muted">Your credentials</span>
            //                         </div>
            //                         <div className="form-group form-group-feedback form-group-feedback-left">

            //                             <input id="username" onChange={this.onusernameChange} value={this.state.username} name="username" placeholder="User Name" type="text" className="form-control" maxlength="35" />

            //                         </div>
            //                         <div className="form-group form-group-feedback form-group-feedback-left">

            //                             <input id="Password" onChange={this.onpasswordChange} value={this.state.password} name="Password" type="password" maxlength="35" className="form-control" placeholder="Password" />

            //                         </div>
            //                         <div className="form-group d-flex align-items-center">
            //                             <div className="form-check mb-0">
            //                                 <label className="form-check-label">
            //                                     <input type="checkbox" name="remember" className="form-input-styled" onChange={this.onrememberChange} value={this.state.remember} /> Remember
            // 						        </label>
            //                             </div>
            //                             <Link to="/forgotpassword" className="ml-auto">Forgot password?</Link>
            //                         </div>
            //                         <div className="form-group">
            //                             <button type="button" className="btn btn-primary btn-block" onClick={this.signin}>Sign in <i className="icon-circle-right2 ml-2"></i></button>
            //                         </div>

            //                         <div className="form-group text-center text-muted content-divider">
            //                             <span className="px-2">Don't have an account?</span>
            //                         </div>
            //                         <div className="form-group">
            //                             <Link to="/register" className="btn btn-light btn-block">Sign up</Link>
            //                         </div>
            //                     </div>
            //                 </div>
            //             </div>
            //         </div>
            //     </div>
            // </div>

        );
    }
}

export default withRouter(Login);